import React from 'react'

function NotFound(props) {
  return (
    <div className='d-flex justify-content-center align-items-center' {...props}>
      No Data Found
    </div>
  )
}

export default NotFound
